import "./App.css";
import { useState, useEffect, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Helmet from "react-helmet";
import { animated, useSpring, easings } from "react-spring";
import emailjs from "@emailjs/browser";
import animatedBg from "./Media/animated.webm";
import { FaStar } from "react-icons/fa";
import { FaBars, FaTimes } from "react-icons/fa";
import { Route, Routes } from "react-router-dom";
import Personal from "./Components/personal.js";
import Property from "./Components/property.js";
import Specific from "./Components/specific.js";
import cityPicture from "./Media/IsoMetricCity.webp";
import resHouse from "./Media/ResHouse.webp";
import construction from "./Media/Construction.webp";
import Privacy from "./Components/privacy.js"

const Home = () => {
  const [scrollY, setScrollY] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  // Define your mobile breakpoint (e.g., 768px)
  const mobileBreakpoint = 768;

  useEffect(() => {
    // Function to check if it's mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth < mobileBreakpoint);
    };

    // Initial check
    checkMobile();

    // Listener for window resize
    window.addEventListener("resize", checkMobile);

    // Scroll listener only if not mobile
    let scrollListener = null;
    if (!isMobile) {
      const handleScroll = () => {
        setScrollY(window.scrollY);
      };
      window.addEventListener("scroll", handleScroll);
      scrollListener = handleScroll; // Store to remove later
    } else {
      // If mobile, ensure scrollY is reset or parallax is not applied
      setScrollY(0);
    }

    // Cleanup function
    return () => {
      window.removeEventListener("resize", checkMobile);
      if (scrollListener) {
        window.removeEventListener("scroll", scrollListener);
      }
    };
  }, [isMobile]); // Re-run effect if isMobile changes

  // Conditionally apply parallax style
  const parallaxStyle1 = !isMobile
    ? {
        transform: `translate3d(0, ${scrollY * 0.6}px, 0)`,
        // Add other base styles for this element here
      }
    : {
        // Define styles for mobile when parallax is off
        // For example, you might want no transform or a static position
        transform: "translate3d(0, 0, 0)", // Or simply {} if no transform needed
        // Add other base styles for this element here
      };

  useEffect(() => {
    AOS.refresh();
  });

  return (
    <>
      <div className="background-wrapper">
        <video autoPlay loop muted>
          <source src={animatedBg} />
        </video>
      </div>
      <div className="parallax-container home-container" style={parallaxStyle1}>
        <div className="home-text" data-aos="fade-down">
          <h2 className="home-title">
            <span className="highlight-gradient">Private Lending</span> Made
            Easy
            <p className="home-description">Loans From $10,000 - $25,000,000</p>
            <button className="cta">
              <a href="#contact" className="cta-link">
                Lets Talk
              </a>
            </button>
          </h2>
          <img className="home-cityimg" src={cityPicture} alt="City" />
        </div>
        <div className="scroll-container">
          <div className="scroller"></div>
        </div>
      </div>
    </>
  );
};

const About = () => {
  useEffect(() => {
    AOS.refresh();
  });
  return (
    <>
      <div className="about-container">
        <div className="text-left" data-aos="fade-right">
          <p className="left-intro highlight-gradient">
            FAST AND EASY QUALIFICATION.
          </p>
          <h1 className="left-title">
            Innovative Lending is a boutique private lending matchmaker,
            offering creative real estate-backed financing solutions for
            individuals who can't obtain funding through traditional channels.
          </h1>
          <p className="left-location ">
            For more than a decade, we’ve been helping businesses and
            individuals across Western Canada access short to medium-term
            mortgage solutions. Our focus is on providing fast, flexible, and
            secure loan options tailored to meet a wide range of financial
            needs, including:
          </p>
          <div className="left-footer ">
            <span>| Residential | </span>
            <span>Commercial | </span>
            <span>Farm/Rural Land | </span>
            <span>Construction | </span>
            <span>Industrial | </span>
            <span>Hotels/Hospitality | </span>
            <span>Re-finance | </span>
            <span>Inventory Loans | </span>
            <span>Buy-Fix-Flip | </span>
            <span>Bridge Loans |</span>
          </div>
          <button className="about-cta">
            <a href="#contact" className="about-cta-link">
              Get to Know Us
            </a>
          </button>
        </div>
        <div className="right-image-holder" data-aos="fade-left">
          <img className="right-image" src={resHouse} alt="House" />
        </div>
      </div>
      <div className="loan-cent">
        <div className="loan-to-value" data-aos="fade-up">
          <h1>MAXIMUM LOAN-TO-VALUE:</h1>
          <span className="value">75% - Urban Residential</span>
          <span className="value">65% - Rural Residential</span>
          <span className="value">60% - Commercial</span>
          <span className="value">59% - Farm Land</span>
        </div>
      </div>
    </>
  );
};

const Process = () => {
  useEffect(() => {
    AOS.refresh();
  });

  return (
    <div className="process-container">
      <div className="process-left-img-container" data-aos="fade-right">
        <img src={construction} alt="Construction" />
      </div>
      <div className="process-right-text-container" data-aos="fade-left">
        <div className="process-right-upper">
          <h1 className="process-title highlight-gradient">LENDING PROCESS</h1>
          <p className="process-description">
            Dynamic Lending is dedicated to guiding borrowers through the
            lending process with speed and efficiency. By working closely with
            you, we make sure your goals, concerns, and unique needs are fully
            understood and addressed
          </p>
        </div>
        <div className="process-right-lower">
          <h2>Our process is simple: </h2>
          <div className="process-list">
            <span>1. Apply through our online portal</span>
            <span>2. Our team will confidentially review your information</span>
            <span>
              3. Funding within 2 weeks of submission, though timelines may vary
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const Footer = () => {
  return (
    <div className="footer-container">
      <span className="footer-title highlight-gradient">Be a client.</span>
      <div className="footer-cta">
        <span className="footer">info@dynamiclending.ca</span>
        <span className="calendly-footer">
          <a href="#contact">Book a Meeting</a>
        </span>
        <span className="calendly-footer">
          <a href="/privacy">Privacy</a>
        </span>
      </div>
    </div>
  );
};

const Contact = () => {
  // --- EmailJS Configuration ---
  // IMPORTANT: Replace these with your actual EmailJS credentials
  const YOUR_SERVICE_ID = "service_se2as97";
  const YOUR_TEMPLATE_ID = "template_yp3bymk";
  const YOUR_PUBLIC_KEY = "v7xLku9cPKPurrMxS"; // Also known as User ID

  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Initialize EmailJS once when the component mounts
  useEffect(() => {
    emailjs.init(YOUR_PUBLIC_KEY);
  }, [YOUR_PUBLIC_KEY]); // Dependency array ensures this runs only if YOUR_PUBLIC_KEY changes (it shouldn't often)

  function sendEmail(event) {
    event.preventDefault();
    setIsSubmitting(true);
    setMessage(""); // Clear previous messages

    const form = event.target;

    const templateParams = {
      firstName: form.firstName.value,
      lastName: form.lastName.value,
      phone: form.phone.value,
      email: form.email.value,
      confirmProperty: form.confirmProperty.checked
        ? "Yes, confirmed"
        : "No, not confirmed", // Send a clear string
      propertyValue: form.propertyValue.value,
      mortgageBalance: form.mortgageBalance.value,
      // You can add any other fields here if needed,
      // ensure they match variables in your EmailJS template
    };

    emailjs
      .send(YOUR_SERVICE_ID, YOUR_TEMPLATE_ID, templateParams)
      .then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);
          setMessage("Application submitted successfully!");
          form.reset(); // Reset the form fields
        },
        function (error) {
          console.log("FAILED...", error);
          setMessage(
            "Application could not be sent. Please try again later or contact us directly."
          );
        }
      )
      .finally(() => {
        setIsSubmitting(false);
      });
  }

  return (
    <div className="form-container" data-aos="fade-down">
      <div className="form-left-content">
        <h1 className="form-apply-title highlight-gradient">APPLY</h1>
        <p className="form-description">
          Complete the provided form to start your application process.
        </p>
        <p className="form-no-credit-check">No credit check required.</p>
        <h2 className="form-inquiries-title">Questions and Inquiries</h2>
        <p className="form-contact-info">
          Any questions or having issues you can email at{" "}
          <a href="mailto:info@dynamiclending.ca">info@dynamiclending.ca</a>
        </p>
      </div>
      <div className="form-right-form">
        {/* Attach the onSubmit handler to the form */}
        <form onSubmit={sendEmail}>
          <div className="form-group">
            <label htmlFor="firstName">
              First Name <span className="required">*</span>
            </label>
            <input
              type="text"
              id="firstName"
              name="firstName" // 'name' attribute is crucial
              required
              placeholder="Enter your first name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="lastName">
              Last Name <span className="required">*</span>
            </label>
            <input
              type="text"
              id="lastName"
              name="lastName" // 'name' attribute is crucial
              required
              placeholder="Enter your last name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">
              Phone Number <span className="required">*</span>
            </label>
            <input
              type="tel"
              id="phone"
              name="phone" // 'name' attribute is crucial
              required
              placeholder="Enter your phone number"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">
              Email <span className="required">*</span>
            </label>
            <input
              type="email"
              id="email"
              name="email" // 'name' attribute is crucial
              required
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group confirmation-text">
            <p>
              Please confirm that you own your property and can provide the
              following up-to-date forms:
            </p>
            <ul>
              <li>Proof of Title</li>
              <li>Proof of Value (Appraisal or Tax Assessment)</li>
              <li>Mortgage Statement (Current Balance)</li>
            </ul>
          </div>
          <div className="form-group checkbox-group">
            <input
              type="checkbox"
              id="confirmProperty"
              name="confirmProperty" // 'name' attribute is crucial
              required
              // No 'value' attribute needed here, we'll check its 'checked' status
            />
            <label htmlFor="confirmProperty">
              I confirm that I own the property and can provide the forms
              listed. <span className="required">*</span>
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="propertyValue">Estimated Property Value</label>
            <input
              type="number"
              id="propertyValue"
              name="propertyValue" // 'name' attribute is crucial
              placeholder="e.g., 500000"
              step="1000"
            />
          </div>
          <div className="form-group">
            <label htmlFor="mortgageBalance">Current Mortgage Balance</label>
            <input
              type="number"
              id="mortgageBalance"
              name="mortgageBalance" // 'name' attribute is crucial
              placeholder="e.g., 200000"
              step="1000"
            />
          </div>
          <button
            type="submit"
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit Application"}
          </button>
          {message && (
            <p
              style={{
                marginTop: "15px",
                color: message.includes("successfully") ? "green" : "red",
              }}
            >
              {message}
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

function App() {
  const [scrollY, setScrollY] = useState(0);
  const [isAnimationComplete, setIsAnimationComplete] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  const [isScrolled, setIsScrolled] = useState(false);

  // Define the animation configuration

  const dropdownAnimation = useSpring({
    clipPath: isOpen ? "inset(0px 0px 0% 0px)" : "inset(0px 0px 100% 0px)",
    opacity: isOpen ? 1 : 0,
    delay: 0,
    config: {
      duration: 500,
      easing: easings.easeInOutSine,
      clamp: true,
      precision: 0.01,
    },
  });

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      // You can adjust the threshold value based on when you want the color change to occur
      const threshold = 500;

      setIsScrolled(scrollPosition > threshold);
    };

    // Attach the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Detach the event listener when the component is unmounted
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures the effect runs only once

  const parallaxStyle1 = {
    transform: `translate3d(0, ${scrollY * 0.6}px, 0)`,
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 200,
    });
  }, []);

  useEffect(() => {
    AOS.refresh();
  });

  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setIsAnimationComplete(false); // Reset the animation completion flag
      }
    };

    // Attach the event listener
    document.addEventListener("click", handleClickOutside);

    // Detach the event listener when the component is unmounted
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []); // Empty dependency array ensures the effect runs only once

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <div className="mobile-nav">
        <div className="menu-icon" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </div>
        <div className="logo">Dynamic Lending</div>
        <nav className={`menu ${isMenuOpen ? "open" : ""}`}>
          <ul>
            <li>
              <a href="/" className="highlight-gradient" onClick={toggleMenu}>
                Home
              </a>
            </li>
            <li>
              <a href="/services/personal" className="highlight-gradient">
                Personal & Debt Management
              </a>
            </li>
            <li>
              <a href="/services/property" className="highlight-gradient">
                Property & Investment
              </a>
            </li>
            <li>
              <a href="/services/specific" className="highlight-gradient">
                Specific Needs
              </a>
            </li>
            <li>
              <a
                href="#contact"
                className="highlight-gradient"
                onClick={toggleMenu}
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <nav
        className={`nav-bar desktop-nav ${isScrolled ? "whiteBg" : ""}`}
        ref={dropdownRef}
      >
        <a
          className={`nav-logo ${isOpen || isScrolled ? "black" : ""}`}
          href="/"
        >
          Dynamic Lending
        </a>
        <ul className="nav-list">
          <li
            className="nav-item"
            onClick={() => {
              setIsOpen(!isOpen);
              setIsAnimationComplete(false);
            }}
          >
            <a
              className={`nav-text ${
                isOpen || isScrolled ? "black hoverBlack" : ""
              }`}
            >
              Solutions
            </a>
            <animated.ul className="dropdown-list" style={dropdownAnimation}>
              <div className="dropdown-entire">
                <li className="nav-websiteDesign">
                  <a className="nav-text-title black" href="/services/personal">
                    Personal & Debt Management
                  </a>
                  <span className="nav-text-option black">
                    Debt Consolidation
                  </span>
                  <span className="nav-text-option black">Personal</span>
                  <span className="nav-text-option black">Taxes/CRA</span>
                </li>
                <li className="nav-socialMedia middle">
                  <a className="nav-text-title black" href="/services/property">
                    Property & Investment
                  </a>
                  <span className="nav-text-option black">Mortgages</span>
                  <span className="nav-text-option black">Renovations</span>
                  <span className="nav-text-option black">Investments</span>
                </li>
                <li className="nav-emailMarketing">
                  <a href="/services/specific" className="nav-text-title black">
                    Specific Needs
                  </a>
                  <span className="nav-text-option black">Business</span>
                  <span className="nav-text-option black">Medical</span>
                  <span className="nav-text-option black">Legal</span>
                </li>
              </div>
            </animated.ul>
          </li>
        </ul>
        <button className={`nav-cta ${isOpen || isScrolled ? "updated" : ""}`}>
          <a
            href="#contact"
            className={`nav-cta-link ${
              isOpen || isScrolled ? "linkUpdated" : ""
            }`}
          >
            Apply
          </a>
        </button>
      </nav>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Helmet>
                <title>
                  Dynamic Lending | Private Equity & Business Financing
                </title>
                <meta
                  name="description"
                  content="Dynamic Lending offers flexible private equity and tailored business loan options to fuel your company's growth. Explore our financing solutions for acquisitions, expansion, and working capital. Partner with us for strategic investment and lending expertise."
                />
                <meta
                  name="keywords"
                  content="private equity, business loans, business financing, commercial lending, investment funding, growth capital, working capital loans, acquisition financing, private lending, business investment, financial solutions, innovative lending, alberta, calgary, canada, chestermere, langdon, airdrie, okotoks"
                />
              </Helmet>
              <div className="component-wrapper">
                <section className="parallax-section home-section" id="home">
                  <Home />
                </section>
              </div>
              <section className="static-section about-section" id="about">
                <About />
              </section>
              <section className="static-section process-section" id="process">
                <Process />
              </section>
              <section className="static-section contact-section" id="contact">
                <Contact />
              </section>
              <section className="static-section footer-section" id="footer">
                <Footer />
              </section>
            </>
          }
        />
        <Route
          path="/services/personal"
          element={
            <>
              <Helmet>
                <title>
                  Personal Loans, Debt Consolidation & CRA Tax Help | Innovative
                  Lending Solutions
                </title>
                <meta
                  name="description"
                  content="Dynamic Lending offers personal loans, debt consolidation services, and assistance with CRA tax issues. Take control of your finances with our tailored solutions. Explore options for managing debt and navigating tax challenges in Calgary."
                />
                <meta
                  name="keywords"
                  content="personal loans, debt consolidation, CRA tax help, tax debt assistance, personal financing, loan consolidation, debt management, financial solutions, tax relief, CRA help, Dynamic Lending, alberta, calgary, canada, chestermere, langdon, airdrie, okotoks"
                />
              </Helmet>
              <div className="component-wrapper">
                <section className="parallax-section home-section" id="home">
                  <Home />
                </section>
              </div>
              <section
                className="static-section personal-section"
                id="personal"
              >
                <Personal />
              </section>
              <section className="static-section contact-section" id="contact">
                <Contact />
              </section>
              <section className="static-section footer-section" id="footer">
                <Footer />
              </section>
            </>
          }
        />
        <Route
          path="privacy"
          element={
            <>
              <Helmet>
                <title>
                  Personal Loans, Debt Consolidation & CRA Tax Help | Innovative
                  Lending Solutions
                </title>
                <meta
                  name="description"
                  content="Dynamic Lending offers personal loans, debt consolidation services, and assistance with CRA tax issues. Take control of your finances with our tailored solutions. Explore options for managing debt and navigating tax challenges in Calgary."
                />
                <meta
                  name="keywords"
                  content="personal loans, debt consolidation, CRA tax help, tax debt assistance, personal financing, loan consolidation, debt management, financial solutions, tax relief, CRA help, Dynamic Lending, alberta, calgary, canada, chestermere, langdon, airdrie, okotoks"
                />
              </Helmet>
              <section
                className="static-section personal-section"
                id="privacy"
              >
                <Privacy />
              </section>
              <section className="static-section contact-section" id="contact">
                <Contact />
              </section>
              <section className="static-section footer-section" id="footer">
                <Footer />
              </section>
            </>
          }
        />
        <Route
          path="/services/property"
          element={
            <>
              <Helmet>
                <title>
                  Mortgage, Renovation & Investment Property Loans | Innovative
                  Lending Solutions
                </title>
                <meta
                  name="description"
                  content="Dynamic Lending offers tailored mortgage loans, financing for home renovations, and investment property loans in Chestermere, Calgary, and surrounding Alberta areas. Secure the right funding for your property goals with our expert guidance. Explore your property financing options today."
                />
                <meta
                  name="keywords"
                  content="mortgage loans, home renovation loans, investment property loans, property financing, real estate loans, home purchase loans, home improvement financing, rental property loans, Chestermere mortgage, Calgary home loans, Alberta property investment, Dynamic Lending"
                />
              </Helmet>
              <div className="component-wrapper">
                <section className="parallax-section home-section" id="home">
                  <Home />
                </section>
              </div>
              <Property />
              <section className="static-section contact-section" id="contact">
                <Contact />
              </section>
              <section className="static-section footer-section" id="footer">
                <Footer />
              </section>
            </>
          }
        />
        <Route
          path="/services/specific"
          element={
            <>
              <Helmet>
                <title>
                  Business, Medical & Legal Loans | Specialized Financing |
                  Dynamic Lending
                </title>
                <meta
                  name="description"
                  content="Dynamic Lending provides specialized business loans, medical financing, and legal fee loans in Chestermere, Calgary, and across Alberta. Access tailored funding solutions for your specific professional or personal needs. Enquire about our targeted loan options today."
                />
                <meta
                  name="keywords"
                  content="business loans, medical loans, legal loans, medical financing, legal fee financing, professional loans, practice financing, commercial loans, healthcare financing, litigation funding, Chestermere business loans, Calgary medical financing, Alberta legal loans, Dynamic Lending"
                />
              </Helmet>
              <div className="component-wrapper">
                <section className="parallax-section home-section" id="home">
                  <Home />
                </section>
              </div>
              <div className="specific-section">
                <Specific />
              </div>
              <section className="static-section contact-section" id="contact">
                <Contact />
              </section>
              <section className="static-section footer-section" id="footer">
                <Footer />
              </section>
            </>
          }
        />
        <Route
          path="/*"
          element={
            <>
              <Helmet>
                <title>404 Not Found - Dynamic Lending</title>
              </Helmet>
              <div className="pageNotFound">
                <h1>404 Not Found</h1>
                <p>Sorry, the page you are looking for does not exist.</p>
              </div>
            </>
          }
        />
      </Routes>
    </>
  );
}

export default App;
